const data = {
    PROPRIETARY: 'Proprietary',
    PARTNER_SHIP: 'Partner Ship',
    PVT_LTD: 'Pvt. Ltd.',
};

export const COMPANY_TYPES = {};

export const COMPANY_TYPES_LIST = Object.keys(data).map((key) => {
    COMPANY_TYPES[key] = key;

    return {
        value: key,
        label: data[key],
    };
});


//payout
export const PAYOUT = {
    LOANAMT_CROSSSALE_LESS_PF : 'LoanAmtCrossSaleLessPF',
    LOANAMT_CROSSSALE: 'LoanAmtCrossSale',
    LOANAMT: 'LoanAmt',
    // NETDISBURSAL: 'NetDisbursal',
    LOANAMT_LESS_PF:'LoanAmtLessPF'
};

export default {
    COMPANY_TYPES,
    COMPANY_TYPES_LIST,
};
